export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8096.08d94a52.jpg";